import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './section.types';

export const sectionSelectors = {
  ...generateResourceSelectors<types.ISection>((state) => state.resource.section),
};
